import { Injectable } from "@angular/core";
import { AppEnvironment } from "./environment.model";
import { environment } from "../../../../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class ConfigService {
  private env: AppEnvironment = environment;

  get countryDefault(): string {
    return this.env.pia.countryDefault;
  }

  get languageDefault(): string {
    return this.env.pia.languageDefault;
  }

  get piaAPIOrigin(): string {
    return this.env.pia.apiOrigin;
  }

  get piaAPIProd(): boolean {
    return this.env.pia.apiProd;
  }

  get piaProductDocumentTypes() {
    return this.env.pia.productDocumentTypes;
  }

  get piaProductImagesTypes() {
    return this.env.pia.productImagesTypes;
  }
}
